import { z } from "zod";

export const AppConfigDto = z.object({
  turnstile: z.object({
    enabled: z.boolean(),
    siteKey: z.string().nullable(),
  }),
});

export type AppConfigDto = z.infer<typeof AppConfigDto>;
